// eslint-disable-next-line
function getPresets(presets, args) {
  var style = {};
  Object.keys(presets).forEach(function (key) {
    style[key] = function (props) {
      var isKeyInArgs = (key in args);

      if (typeof presets[key] === 'object' && isKeyInArgs) {
        var valueMappedToProps = presets[key][props[args[key]]];

        if (!valueMappedToProps) {
          // eslint-disable-next-line no-console
          console.error("Value for prop \"" + args[key] + "\" invalid!");
          return presets[key];
        }

        return "" + valueMappedToProps;
      }

      if (isKeyInArgs) {
        return "" + args[key];
      }

      return "" + presets[key];
    };
  });
  return style;
}

export { getPresets };
